/**
 * MapLegend
 * =========
 * Place at: frontend/src/components/map/MapLegend.jsx
 *
 * Extracted from Dashboard.jsx (September 2026). It shares no state with
 * the page — it takes props and renders — so living inside a 1,100-line
 * page component bought nothing and cost reuse.
 *
 * Reusable by any map surface. The cohort map has no legend today and
 * arguably should — the interaction vocabulary is identical.
 */

import React from 'react';
import { X } from 'lucide-react';


export const MapLegend = ({ show, onClose }) => {
  if (!show) return null;
  return (
    <div className="absolute bottom-20 right-4 z-40 w-64 bg-zinc-900/95 backdrop-blur-xl border border-zinc-800 rounded-xl p-4 shadow-2xl animate-in slide-in-from-bottom-2 fade-in duration-200">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-bold text-zinc-300 uppercase tracking-wider">Legend</span>
        <button onClick={onClose} className="text-zinc-500 hover:text-white transition-colors">
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
      <div className="space-y-3 text-xs">
        <div className="flex items-center gap-2.5">
          <div className="w-6 h-6 rounded-full border-2 border-purple-500 bg-zinc-900 flex-shrink-0" />
          <span className="text-zinc-400">Project (ring = physical/digital/hybrid)</span>
        </div>
        <div className="flex items-center gap-2.5">
          <div className="w-5 h-5 rotate-45 border-2 border-amber-500 bg-zinc-900 flex-shrink-0 ml-0.5" />
          <span className="text-zinc-400 ml-0.5">Challenge &mdash; a call for help</span>
        </div>
        <div className="h-px bg-zinc-800" />
        <div className="flex items-center gap-2.5">
          <div className="w-6 h-px bg-zinc-600 flex-shrink-0" />
          <span className="text-zinc-400">Same-zone connection</span>
        </div>
        <div className="flex items-center gap-2.5">
          <div className="w-6 h-0.5 bg-gradient-to-r from-purple-500 to-cyan-500 rounded flex-shrink-0" />
          <span className="text-zinc-400">Cross-zone connection</span>
        </div>
        <div className="h-px bg-zinc-800" />
        <div className="text-zinc-500 space-y-1 leading-relaxed">
          <p><b className="text-zinc-400">Click</b> node &rarr; light lineage</p>
          <p><b className="text-zinc-400">Double-click</b> &rarr; open details</p>
          <p><b className="text-zinc-400">Shift+click</b> &rarr; multi-select</p>
          <p><b className="text-zinc-400">Click line</b> &rarr; show full chain</p>
          <p><b className="text-zinc-400">Click empty space</b> &rarr; reset</p>
        </div>
      </div>
    </div>
  );
};

export default MapLegend;